import React from "react";
import intl from "react-intl-universal";

import {ContextMenuInterface} from "../../ContextMenuInterface";

import {InfoIcon} from "../../../../components/icons/InfoIcon";
import {WarningIcon} from "../../../../components/icons/WarningIcon";
import {DangerIcon} from "../../../../components/icons/DangerIcon";
import {SuccessIcon} from "../../../../components/icons/SuccessIcon";

import {DeleteIcon} from "../../../../components/icons/DeleteIcon";

import {
  setTypeInfo,
  setTypeDanger,
  setTypeSuccess,
  setTypeWarning
} from "../../../../../Editor/module/commands/common/setCalloutType";

import {deleteNode} from "../../../../../Editor/module/commands/common/deleteNode";
import {isAttributeValueActive} from "../../../../../Editor/utils/isAttributeValueActive";

import {schema} from '../../../../../Editor/module/config/schema';


import {GroupedActions, ContextAction} from "../utils/GroupedActions";

export interface ImageContextPropsSelfProps {
  getPos: () => number | undefined,
}

export interface ImageToolbarProps extends ContextMenuInterface, ImageContextPropsSelfProps {
}


const groupedAdminActions: ContextAction[][] = [
  [
    {
      id: 'info',
      Icon: InfoIcon,
      getTitle: () => intl.get('common.info').d('Info'),
      action: setTypeInfo,
      active: isAttributeValueActive(schema.nodes.callout, 'type', 'info'),
    },
    {
      id: 'warning',
      Icon: WarningIcon,
      getTitle: () => intl.get('common.warning').d('Warning'),
      action: setTypeWarning,
      active: isAttributeValueActive(schema.nodes.callout, 'type', 'warning'),
    },
    {
      id: 'danger',
      Icon: DangerIcon,
      getTitle: () => intl.get('common.danger').d('Danger'),
      action: setTypeDanger,
      active: isAttributeValueActive(schema.nodes.callout, 'type', 'danger'),
    },
    {
      id: 'success',
      Icon: SuccessIcon,
      getTitle: () => intl.get('common.success').d('Success'),
      action: setTypeSuccess,
      active: isAttributeValueActive(schema.nodes.callout, 'type', 'success'),
    },
    {
      id: 'delete',
      Icon: DeleteIcon,
      getTitle: () => intl.get('common.delete').d('Delete'),
      action: deleteNode,
    },
  ],
];


export const CalloutToolbar = ({handleClose, isDark, ...specificParams}: ImageToolbarProps) => {
  return <GroupedActions
    handleClose={handleClose}
    actionGroups={groupedAdminActions}
    additionalParams={specificParams}
    isDark={isDark}
  />
}
